// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_fix__RtzLB {
  background-color: red;
  font-weight: 700;
  padding: 4px;
  text-align: center;
}

.Header_logo__t-Kgx {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
}

.Header_container__z3KL1 {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  padding-bottom: 12px;
  position: relative;
}
.Header_container__z3KL1 .Header_content__Loq5- {
  display: flex;
  justify-content: space-between;
  width: 85%;
  margin: 0 auto;
}
.Header_container__z3KL1 .Header_left__ambxT {
  align-items: center;
  display: flex;
  gap: 40px;
}
.Header_container__z3KL1 .Header_left__ambxT .Header_pmPass__WiJKA {
  display: none;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
}
.Header_container__z3KL1 .Header_left__ambxT .Header_nav__0SBAX {
  align-items: center;
  color: #ffffff;
  display: flex;
  gap: 24px;
}
.Header_container__z3KL1 .Header_left__ambxT .Header_nav__0SBAX .Header_selected__7pJFY {
  color: #EAD40C;
}
.Header_container__z3KL1 .Header_right__MCOr7 {
  display: flex;
  gap: 32px;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_lang__y1hXx {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  gap: 4px;
  display: flex;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_lang__y1hXx .Header_langItem__AHDLj {
  cursor: pointer;
  transition: all 0.2s linear;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_yellow__Nc7k3 {
  color: #EAD40C;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_loginBtn__0v38M {
  display: block;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_login__gbJcH {
  display: none;
  align-items: center;
  gap: 6px;
  color: #C2BDB2;
  font-size: 16px;
  font-weight: 600;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_btn__dzLcD {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  border-radius: 8px;
  cursor: pointer;
  padding: 10px 22px;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_btns__2prPM {
  align-items: center;
  display: flex;
  gap: 24px;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_auth__\\+KVzk {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #C2BDB2;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  gap: 20px;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_auth__\\+KVzk .Header_points_row__57VUn {
  display: flex;
  gap: 5px;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_auth__\\+KVzk .Header_points__CXq8R {
  align-items: center;
  display: flex;
  gap: 4px;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_auth__\\+KVzk .Header_pointsValue__BRyy\\+ {
  font-size: 16px;
  font-weight: 600;
  color: #FAF9F8;
  text-align: center;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_auth__\\+KVzk .Header_line__mfu4c {
  background-color: rgba(255, 255, 255, 0.1490196078);
  height: 32px;
  width: 1px;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_auth__\\+KVzk .Header_profile__ku2l8 {
  align-items: center;
  color: #FFFFFF;
  display: flex;
  gap: 8px;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_auth__\\+KVzk .Header_profile__ku2l8 .Header_profileImg__wBMMe {
  width: 48px;
}
.Header_container__z3KL1 .Header_right__MCOr7 .Header_enter__RVHaz {
  background-color: #333217;
  color: #EAD40C;
}
.Header_container__z3KL1 .Header_hoverY__z-sZH {
  font-family: "Open Sans SemiBold";
  font-size: 20px;
  letter-spacing: -0.02em;
  color: #dad6ce;
  transition: all 0.2s linear;
}
.Header_container__z3KL1 .Header_hoverY__z-sZH:hover {
  color: #F2F740;
}
.Header_container__z3KL1 .Header_hoverY__z-sZH.Header_active__cUDs0 {
  color: #F2F740;
}

@media (max-width: 1100px) {
  .Header_container__z3KL1 .Header_content__Loq5- .Header_left__ambxT .Header_pmPass__WiJKA {
    display: block;
  }
  .Header_container__z3KL1 .Header_content__Loq5- .Header_left__ambxT .Header_nav__0SBAX {
    display: none;
  }
  .Header_container__z3KL1 .Header_content__Loq5- .Header_right__MCOr7 .Header_login__gbJcH {
    display: flex;
  }
  .Header_container__z3KL1 .Header_content__Loq5- .Header_right__MCOr7 .Header_loginBtn__0v38M {
    display: none;
  }
  .Header_container__z3KL1 .Header_content__Loq5- .Header_right__MCOr7 .Header_auth__\\+KVzk .Header_line__mfu4c,
  .Header_container__z3KL1 .Header_content__Loq5- .Header_right__MCOr7 .Header_auth__\\+KVzk .Header_profile__ku2l8 {
    display: none;
  }
}
.Header_langDropdown__2fWQO {
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/header/Header.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AADF;;AAIA;ECqBE,eAAA;EACA,gBAAA;EACA,kBAAA;EDpBA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,iBAAA;EACA,+CAAA;EACA,kDAAA;EACA,oBAAA;EACA,kBAAA;AAAF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,cAAA;AAAJ;AAGE;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AADJ;AAGI;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADN;AAII;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAFN;AAKM;EACE,cAAA;AAHR;AAQE;EACE,aAAA;EACA,SAAA;AANJ;AAQI;ECxBF,eAAA;EACA,gBAAA;EACA,kBAAA;EDyBI,mBAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AALN;AAOM;EACE,eAAA;EACA,2BAAA;AALR;AASI;EACE,cAAA;AAPN;AAUI;EACE,cAAA;AARN;AAWI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AATN;AAYI;ECjDF,eAAA;EACA,gBAAA;EACA,kBAAA;EDkDI,kBAAA;EACA,eAAA;EACA,kBAAA;AATN;AAYI;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AAVN;AAaI;EC3EF,eAAA;EACA,gBAAA;EACA,kBAAA;ED4EI,mBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAVN;AAYM;EACE,aAAA;EACA,QAAA;AAVR;AAaM;EACE,mBAAA;EACA,aAAA;EACA,QAAA;AAXR;AAcM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAZR;AAeM;EACE,mDAAA;EACA,YAAA;EACA,UAAA;AAbR;AAgBM;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;AAdR;AAgBQ;EACE,WAAA;AAdV;AAmBI;EACE,yBAAA;EACA,cAAA;AAjBN;AAqBE;EACE,iCAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EAEA,2BAAA;AApBJ;AAsBI;EACE,cEpKK;AFgJX;AAuBI;EACE,cAAA;AArBN;;AA0BA;EAKQ;IACE,cAAA;EA3BR;EA8BM;IACE,aAAA;EA5BR;EAiCM;IACE,aAAA;EA/BR;EAkCM;IACE,aAAA;EAhCR;EAqCQ;;IAEE,aAAA;EAnCV;AACF;AA0CA;EACE,WAAA;AAxCF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.fix {\n  background-color: red;\n  font-weight: 700;\n  padding: 4px;\n  text-align: center;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 70px;\n}\n\n.container {\n  @include subtitle4m;\n\n  left: 0;\n  margin: 0 auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  padding-bottom: 12px;\n  position: relative;\n\n  .content {\n    display: flex;\n    justify-content: space-between;\n    width: 85%;\n    margin: 0 auto;\n  }\n\n  .left {\n    align-items: center;\n    display: flex;\n    gap: 40px;\n\n    .pmPass {\n      display: none;\n      font-size: 20px;\n      font-weight: 600;\n      color: #ffffff;\n    }\n\n    .nav {\n      align-items: center;\n      color: #ffffff;\n      display: flex;\n      gap: 24px;\n\n\n      .selected {\n        color: #EAD40C;\n      }\n    }\n  }\n\n  .right {\n    display: flex;\n    gap: 32px;\n\n    .lang {\n      @include subtitle5;\n\n      align-items: center;\n      color: #ffffff;\n      gap: 4px;\n      display: flex;\n\n      .langItem {\n        cursor: pointer;\n        transition: all .2s linear;\n      }\n    }\n\n    .yellow {\n      color: #EAD40C;\n    }\n\n    .loginBtn {\n      display: block;\n    }\n\n    .login {\n      display: none;\n      align-items: center;\n      gap: 6px;\n      color: #C2BDB2;\n      font-size: 16px;\n      font-weight: 600;\n    }\n\n    .btn {\n      @include subtitle6m;\n\n      border-radius: 8px;\n      cursor: pointer;\n      padding: 10px 22px;\n    }\n\n    .btns {\n      align-items: center;\n      display: flex;\n      gap: 24px;\n    }\n\n    .auth {\n      @include subtitle4m;\n\n      align-items: center;\n      color: #C2BDB2;\n      display: flex;\n      font-size: 14px;\n      font-weight: 600;\n      gap: 20px;\n\n      .points_row {\n        display: flex;\n        gap: 5px;\n      }\n\n      .points {\n        align-items: center;\n        display: flex;\n        gap: 4px;\n      }\n\n      .pointsValue {\n        font-size: 16px;\n        font-weight: 600;\n        color: #FAF9F8;\n        text-align: center;\n      }\n\n      .line {\n        background-color: #FFFFFF26;\n        height: 32px;\n        width: 1px;\n      }\n\n      .profile {\n        align-items: center;\n        color: #FFFFFF;\n        display: flex;\n        gap: 8px;\n\n        .profileImg {\n          width: 48px;\n        }\n      }\n    }\n\n    .enter {\n      background-color: #333217;\n      color: #EAD40C;\n    }\n  }\n\n  .hoverY {\n    font-family: \"Open Sans SemiBold\";\n    font-size: 20px;\n    letter-spacing: -0.02em;\n    color: #dad6ce;\n\n    transition: all .2s linear;\n\n    &:hover {\n      color: $c-yellow;\n    }\n\n    &.active {\n      color: #F2F740;\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .container {\n\n    .content {\n      .left {\n        .pmPass {\n          display: block;\n        }\n\n        .nav {\n          display: none;\n        }\n      }\n\n      .right {\n        .login {\n          display: flex;\n        }\n\n        .loginBtn {\n          display: none;\n        }\n\n        .auth {\n\n          .line,\n          .profile {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n.langDropdown {\n  width: auto;\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #F2F740;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n// New colors\n\n$icon-main: #EAD40C;\n$icon-secondary: #7B756B;\n$icon-chevron: #BBB5AA;\n$icon-always-dark: #212329;\n$icon-primary-control: #292621;\n$icon-hover: #575249;\n$icon-pressed: #575249;\n$icon-white: #ffffff;\n$icon-notification: #FF3333;\n$icon-warning: #E2B603;\n$icon-deposit: #009E69;\n\n$light-10: rgba(255, 255, 255, .1);\n$light-15: rgba(255, 255, 255, .15);\n$light-30: rgba(255, 255, 255, .3);\n$light-45: rgba(255, 255, 255, .45);\n$light-50: rgba(255, 255, 255, .5);\n$light-60: rgba(255, 255, 255, .6);\n\n$background-main: #171716;\n$background-secondary: #292621;\n$background-snackbar: #000000;\n$background-input: #3E3C37;\n\n$control-primary: #F2F740;\n$control-hover: #F5F966;\n$control-pressed: #E6EB3D;\n$control-green: #009E69;\n$control-green-hover: #33B187;\n$control-green-pressed: #009664;\n$control-dark: #3E3C37;\n$control-dark-hover: #51504B;\n$control-dark-pressed: #3B3934;\n$control-light: #FFFFFF;\n$control-light-hover: #E5E5E5;\n$control-light-pressed: #D9D9D9;\n$control-light-toggle: #B7B7B7;\n\n$text-title: #FAF9F8;\n$text-subtitle: #DAD6CE;\n$text-body: #C2BDB2;\n$text-link: #00D68F;\n$text-error: #FF3333;\n$text-warning: #E2B603;\n$text-white: #FFFFFF;\n$text-dark: #292621;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fix": `Header_fix__RtzLB`,
	"logo": `Header_logo__t-Kgx`,
	"container": `Header_container__z3KL1`,
	"content": `Header_content__Loq5-`,
	"left": `Header_left__ambxT`,
	"pmPass": `Header_pmPass__WiJKA`,
	"nav": `Header_nav__0SBAX`,
	"selected": `Header_selected__7pJFY`,
	"right": `Header_right__MCOr7`,
	"lang": `Header_lang__y1hXx`,
	"langItem": `Header_langItem__AHDLj`,
	"yellow": `Header_yellow__Nc7k3`,
	"loginBtn": `Header_loginBtn__0v38M`,
	"login": `Header_login__gbJcH`,
	"btn": `Header_btn__dzLcD`,
	"btns": `Header_btns__2prPM`,
	"auth": `Header_auth__+KVzk`,
	"points_row": `Header_points_row__57VUn`,
	"points": `Header_points__CXq8R`,
	"pointsValue": `Header_pointsValue__BRyy+`,
	"line": `Header_line__mfu4c`,
	"profile": `Header_profile__ku2l8`,
	"profileImg": `Header_profileImg__wBMMe`,
	"enter": `Header_enter__RVHaz`,
	"hoverY": `Header_hoverY__z-sZH`,
	"active": `Header_active__cUDs0`,
	"langDropdown": `Header_langDropdown__2fWQO`
};
export default ___CSS_LOADER_EXPORT___;
